export default __webpack_public_path__ + "static/media/play-button-blue.863dcad4.svg";